const html = require('choo/html');
const { isWeChatEmbeddedBrowser, copyToClipboard } = require('../utils');

/** QQ Mail no longer serves /cgi-bin/compose (404). Open webmail + copy draft text. */
const QQ_MAIL_WEB = 'https://mail.qq.com';

function shareWeChatNotice(state) {
  if (!isWeChatEmbeddedBrowser()) {
    return null;
  }
  return html`
    <div
      role="status"
      class="w-full mb-4 p-3 rounded-lg border text-left text-sm border-amber-500/50 bg-amber-50 text-grey-90 dark:bg-amber-900/25 dark:border-amber-400/40 dark:text-grey-10"
    >
      <p class="font-semibold mb-1">
        ${state.translate('weChatInAppHintTitle')}
      </p>
      <p class="leading-normal text-grey-80 dark:text-grey-30">
        ${state.translate('weChatInAppHint')}
      </p>
    </div>
  `;
}

function shareEmailLink(state, name, url, options) {
  const opts =
    typeof options === 'string'
      ? { extraClass: options }
      : options || {};
  const { extraClass: blockClass = '', plain = false } = opts;
  const primaryClass =
    'btn p-0 rounded-lg w-full min-h-12 py-3 focus:outline-none bg-blue-60 hover:bg-blue-70 text-white flex flex-row items-center justify-center transition-colors shadow-sm relative overflow-hidden';
  const plainClass =
    'btn rounded-lg w-full flex-shrink-0 focus:outline flex flex-row items-center justify-center';
  const btnClass = plain ? plainClass : primaryClass;

  async function onQqMailShareClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    const subject = state.translate('shareEmailSubject', { name });
    const body = state.translate('shareEmailBody', { name, url });
    const text = `${subject}\n\n${body}`;

    let copied = false;
    if (
      typeof navigator !== 'undefined' &&
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === 'function' &&
      window.isSecureContext
    ) {
      try {
        await navigator.clipboard.writeText(text);
        copied = true;
      } catch (e) {
        copied = false;
      }
    }
    if (!copied) {
      copied = copyToClipboard(text);
    }

    window.open(QQ_MAIL_WEB, '_blank', 'noopener,noreferrer');
  }

  return html`
    <div class="w-full ${blockClass}">
      <button
        type="button"
        class="${btnClass} w-full"
        title="${state.translate('shareEmailButton')}"
        onclick="${onQqMailShareClick}"
      >
        <span class="flex items-center justify-center pointer-events-none">
          <svg
            class="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          <span class="font-medium text-base leading-none">${state.translate(
            'shareEmailButton'
          )}</span>
        </span>
      </button>
      <p
        class="mt-2 text-xs text-center text-grey-60 dark:text-grey-40 leading-snug px-1"
      >
        ${state.translate('shareEmailClientHint')}
      </p>
    </div>
  `;
}

module.exports = {
  shareWeChatNotice,
  shareEmailLink
};
